import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Spinner } from './Spinner';
import { cx } from './cx';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  fullWidth?: boolean;
  loading?: boolean;
  icon?: ReactNode;
}

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary: 'bg-accent text-bg hover:bg-accent-strong active:bg-accent-strong',
  secondary:
    'bg-surface-raised text-ink border border-line hover:border-ink-faint active:bg-surface',
  ghost: 'bg-transparent text-ink-muted hover:text-ink active:text-ink',
  danger: 'bg-danger text-bg hover:brightness-95 active:brightness-90',
};

/** Botão com alvo de toque grande (mín. 52px) — captura rápida em campo, uma mão. */
export function Button({
  variant = 'primary',
  fullWidth = false,
  loading = false,
  icon,
  disabled,
  className,
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      type="button"
      className={cx(
        'inline-flex min-h-[52px] items-center justify-center gap-2 rounded-lg px-5',
        'font-display text-[15px] font-semibold tracking-tight',
        'transition-colors duration-150 disabled:cursor-not-allowed disabled:opacity-45',
        fullWidth && 'w-full',
        VARIANT_CLASS[variant],
        className,
      )}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? <Spinner /> : icon}
      {children}
    </button>
  );
}
